import { LookupTypeDto } from "../app/model/api/types/dto";
import { LookupViewModel } from "./lookupViewModel";

export class LookupTypeViewModel extends LookupViewModel {
  isGrouped: boolean | null;

  constructor(
    id: string | null,
    name: string | null,
    description: string | null,
    sortValue: number | null,
    isActive: boolean | null,
    isGrouped: boolean | null
  ) {
    super(id, name, description, sortValue, isActive);
    this.isGrouped = isGrouped;
  }

  toDto(): LookupTypeDto {
    return {
      id: this.id,
      isActive: this.isActive,
      name: this.name,
      description: this.description,
      sortValue: Number(this.sortValue),
      isGrouped: this.isGrouped,
    };
  }

  mapFromDto(dto: LookupTypeDto): void {
    super.mapFromDto(dto);
    this.isGrouped = dto.isGrouped;
  }
}
